<template>
  <div>
    <CrudList
      title="Marcas de autos"
      storeName="Car_brands"
      labelAddNew="Agregar"
      :canAdd="true"
      :canEdit="true"
      :canDelete="true"
      sortable
      next-link="/admin/type_spots"
      :breadcrumbs="[
        {
          text: 'Spots y vehículos',
          disabled: false,
          href: '/admin/car_brands'
        },
        {
          text: 'Marcas de autos',
          disabled: false,
          href: '#'
        },
      ]"
    >
      <template v-slot:car_models="{ item }">
        <v-btn
            elevation="0"
            class="my-1 btn-black btn-round-md" 
            rounded
            color="primary"
            @click="$router.push('/admin/car_brands/' + item.id + '/car_models')"
        >
          Modelos 
        </v-btn>
      </template>
    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
